export default "__VITE_ASSET__8f349e28__"